import { render, staticRenderFns } from "./JudgeCases.vue?vue&type=template&id=77682316"
import script from "./JudgeCases.vue?vue&type=script&lang=js"
export * from "./JudgeCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports